<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                (click)="addExpenseCategory(0)" [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Expense Category':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Expense Category Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered" style="width: 100%;">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th>Category Name</th>
                        <th style="width: 20px;">GLCode</th>
                        <th style="width: 20px;">Local</th>
                        <th style="width: 20px;">OutStation</th>
                        <th style="width: 20px;">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center"><i
                                    (click)="addExpenseCategory(TableData['ESS_ExpenseCategoryMasterId'])"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                        <td>{{TableData['ExpenseCategoryName']}}</td>
                        <td style="width: 20px;">{{TableData['AccountGLCode']}}</td>
                        <td style="width: 20px;">{{TableData['IsLocal']?'Yes':'No'}}</td>
                        <td style="width: 20px;">{{TableData['IsOutStation']?'Yes':'No'}}</td>
                        <td style="width: 20px;"><span class="badge"
                                [ngClass]="{'success': TableData['IsActive'],'danger': !TableData['IsActive'],}">
                                {{TableData['IsActive']?'Active':'Deactive'}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>